<template>
  <div class="teacher">
      <h1 class="ml-3 mt-3">Welcome Jena</h1>
      <v-container>
      <v-layout row>
          <v-layout column xs5 sm5 lg5 xl5 md5>
            <div style="height:700px;">
                <!-- <v-img :src="picture" alt=""></v-img> -->
            <v-select :items="items" v-model="assigning" @change="notess" class="ml-8 mt-10" style="width:300px;height:80px;" label="Select New" solo></v-select>
            <v-select :items="tests" v-show="!notes" v-model="name" class="ml-8 " style="width:300px;height:80px;" label="Exam type" solo></v-select>
            <v-text-field v-show="notes" outlined label="Notes name" v-model="name"></v-text-field>
            <v-select :items="subs" v-model="subject" class="ml-8 " style="width:300px;height80px;" label="Subject" solo></v-select>
            <v-text-field label="Due data" outlined v-model="date"></v-text-field>
            <!-- <v-progress-linear :buffervalue="uploadValue.toFixed()+'%'"></v-progress-linear> -->
            <v-file-input class="ml-6" @change="previewImage" accept="file/*" style="width:300px;height:50px;" outlined></v-file-input>
            <v-btn @click.prevent="onUpload" class="mt-8 ml-16" width="60px" height="30">Post</v-btn>
            </div>
            </v-layout>
            <v-layout column xs7 sm7 lg7 xl7 md7>
                <h1>The Overdue List</h1>
                <v-flex  v-for="overdue in overdues" class="ml-4" :key="overdue.name">
                    <div style="margin-bottom:20px;border:3px solid black;border-radius:2%;" class="pl-3"  >
                    <h3>{{overdue.subject}}</h3>
                    <h4>Due Date : {{overdue.due}}</h4>
                    <v-flex v-for="list in overdue.lists" :key="list.name">
                        <p>{{list.name}}</p>
                    </v-flex>
                    </div>
                </v-flex>
            </v-layout>
      </v-layout>
      </v-container>
  </div>
</template>

<script>
import db from '../components/firebaseinit'
import firebase from 'firebase'
export default {
    data(){
        return{
            items:["New Test/Assignment","New Notes"],
            tests:["Unit Test","Cycle Test","Assignment","Notes"],
            subs:["Cyrtography and Network Security","Human Computer Interaction","Hospital Management","Service Oriented Architecture","Principles of Management","Cloud Computing"],
            unsubs:[
                {sub:"CNS",ppls:{1:"Pon Sankar",2:"Baby",3:"Benks"},due:"21/09/2020",color:"blue lighten-2"},
                {sub:"SOA",ppls:{1:"Pon Sankar",2:"Baby",3:"Benks"},due:"22/09/2020",color:"green lighten-2"},
                {sub:"HCI",ppls:{1:"Pon Sankar",2:"Baby",3:"Benks"},due:"22/09/2020",color:"purple lighten-2"},
                {sub:"HM",ppls:{1:"Pon Sankar",2:"Baby",3:"Benks"},due:"22/09/2020",color:"pink lighten-2"}
            ],
            assigning:null,
            subject:null,
            name:null,
            date:null,
            students:[],
            i:0,
            overdues:[],
            uploadValue:null,
            imageData:null,
            picture:null,
            notes:false
        }
    },
    methods:{
        notess:function(){
            if(this.assigning=="New Notes")
            this.notes=true
            else
            this.notes=false
        },
        // add:function(){
        
        //     db.collection('tests').add({
        //         type: this.assigning,
        //         Sub: this.subject,
        //         Name:this.name,
        //         Due:this.date,
        //         status:this.students,
        //         qlink:this.picture
        //     }).then(docref => {
        //         console.log(this.students)
        //         console.log(docref)
        //         // this.$router.push('/')
        //     }).catch(err => console.log(err))
                        
        // },
        previewImage:function(event){
            this.uploadValue=0
            this.picture=null
            console.log(event.name)
            this.imageData= event
            console.log(this.imageData)
        },
        onUpload:function(){
            this.picture=null
            const storageRef=firebase.storage().ref(`${this.imageData.name}`).put(this.imageData)
            storageRef.on('state_changed',snapshot => {
                this.uploadValue=(snapshot.bytesTransferred/snapshot.totalBytes)*100
            },err => {console.log(err.message)},
            ()=>{
                // this.uploadValue=100
                storageRef.snapshot.ref.getDownloadURL().then((url)=> {
                    this.picture=url
                    console.log(url)
                    console.log(this.students)
                    if(this.assigning!="New Notes"){
                        db.collection('tests').add({
                        type: this.assigning,
                        Sub: this.subject,
                        Name:this.name,
                        Due:this.date,
                        status:this.students,
                        qlink:this.picture
                    }).then(docref => {
                        console.log(this.students)
                        console.log(docref)
                        // this.$router.push('/')
                    }).catch(err => console.log(err))
                }else{
                    db.collection('notes').add({
                    type: this.assigning,
                    Sub: this.subject,
                    Name:this.name,
                    Due:this.date,
                    qlink:this.picture
                    }).then(docref => {
                    console.log(this.students)
                    console.log(docref)
                    // this.$router.push('/')
                    }).catch(err => console.log(err))
                }
                })
                
            }
            )

        }
    },
    beforeMount:function(){
         db.collection('students').get().then(doc => {
                console.log(doc.size)
                doc.forEach(r => {
                    this.students.push({name:r.data().Name,stat:false,link:null})
                    this.i=this.i+1
                })
                console.log(this.students)   
            })
        db.collection('tests').get().then(doc => {
                console.log(doc.size)
                doc.forEach(r => {
                    var duelist=[]
                    // console.log(r.data().status)
                    r.data().status.forEach(a => {
                        if(a.stat==false){
                            duelist.push({name:a.name})
                            // console.log(a)
                        }
                    })
                    this.overdues.push({subject:r.data().Sub,due:r.data().Due,lists:duelist})
                    
                })
                console.log(this.overdues)
                console.log("hi")
                
            })    
    }
}
</script>

<style scoped>
.v-text-field{
  width: 300px !important;
  margin-left: 30px;
}
/* input{
    border:2px solid blue;
    width:350px;
    /* circular-radius: 1%; 
} */
</style>